import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/account";
import {PaymentElementView} from "./payment_element";
import { ShopItem } from "../bo/shop_item";
import jQuery from "jquery";
import {Balance} from "../bo/balance";
import {renderCredits, renderEuros} from "../misc/utils";

export class AccountView extends View {

    static classname = "account-view";

    private readonly server = Server.instance();

    private paymentElementView = new PaymentElementView();

    private items? : ShopItem[];

    private balance? : Balance;

    private result: string | undefined;

    constructor() {
        super(AccountView.classname);
        this.listenForPayment();
        this.server.fetchShopCatalogue().then(items => {
            this.items = items;
            this.update();
        });
        this.refresh();
    }

    refresh() {
        this.server.getBalance().then(b => {
            this.balance = b;
            this.update(".balance");
        });
    }

    private listenForPayment() {
        const paid_ = this.paymentElementView.getPromise();
        paid_.then((x) => {
            const pi = x.paymentIntent;
            const amtCents = pi.amount;
            const currency = pi.amount;
            const status = pi.status;
            if (status == "succeeded") {
                this.addOrder(pi);
            }
        });
        paid_.catch(() => {
            this.paymentElementView.newPromise();
            this.listenForPayment();
        });
    }

    async addOrder(paymentIntent: any) {
        const data = await this.server.purchase(paymentIntent);
        this.result = data.result;

        this.update(".result-section");

        this.refresh();
    }

    protected render0(): JQuery<HTMLElement> {
        const data = {
            balance: this.balance,
            items: this.items,
            paymentElementView: this.paymentElementView,
            renderCredits: renderCredits,
            renderEuros: renderEuros,
            result: this.result,
        };

        const out = this.pug(template, data);
        return out;
    }

    setChoice(idx: number) {
        if (! this.items) {
            return;
        }
        const item = this.items[idx];
        const intent_ = this.paymentElementView.createIntent(item.cents as number / 100, item.description as string);

        intent_.then(() => {
            const pelt = this.paymentElementView.elt();
            const offset = pelt && pelt.offset();
            if (offset) {
                jQuery("html, body").animate({
                    scrollTop: offset.top
                }, 100);
            }
        });
    }

}

View.on("." + AccountView.classname,
    "change",
    "input[name='shop_item_idx']",
    function(that: AccountView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).val() as number;
        that.setChoice(idx)
    });
